import React from 'react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { BoxIcon, CreditCardIcon, CalendarIcon, PauseIcon, XIcon } from 'lucide-react';
const ManageSubscriptions = () => {
  const dk = useDarkClasses();
  const subscriptions = [{
    id: 1,
    name: 'Bookish & Spice Box',
    plan: 'Monthly',
    price: 39.99,
    nextBilling: 'Nov 15, 2023',
    status: 'Active',
    image: 'https://images.unsplash.com/photo-1603162361777-1f802e442ecf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800'
  }];
  return <div className={`min-h-screen ${dk.isDark ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-4243" data-mp="3tue5dd9il49">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4244" data-mp="co901ysastwc">
        <h1 className="text-3xl font-bold mb-8" data-id="element-4245" data-mp="cqlh89q8f08c">Manage Subscriptions</h1>

        <div className="space-y-6" data-id="element-4246" data-mp="howvcwnk7wwd">
          {subscriptions.map(sub => <div key={sub.id} className={`rounded-xl shadow-sm overflow-hidden ${dk.isDark ? 'bg-gray-800' : 'bg-white'}`} data-id="element-4247" data-mp="mlvhot0zezk0">
              <div className="p-6 sm:flex sm:items-center sm:justify-between" data-id="element-4248" data-mp="3924f8fc58bmt">
                <div className="flex items-center" data-id="element-4249" data-mp="3948s3ms0skz8">
                  <img src={sub.image} alt={sub.name} className="h-16 w-16 rounded-lg object-cover" data-id="element-4250" data-mp="351kgx8fu31z3" />
                  <div className="ml-4" data-id="element-4251" data-mp="muf3crtdgho">
                    <h3 className="text-lg font-bold" data-id="element-4252" data-mp="lt57bmjb01j">{sub.name}</h3>
                    <p className={`text-sm ${dk.isDark ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-4253" data-mp="3spvd3yal4dh1">
                      {sub.plan} Plan • ${sub.price}/mo
                    </p>
                    <div className="mt-1 flex items-center text-xs text-green-500 font-medium" data-id="element-4254" data-mp="3izisk62rskaw">
                      <span className="h-2 w-2 rounded-full bg-green-500 mr-2" data-id="element-4255" data-mp="kb3jcl6mtcxj"></span>
                      {sub.status}
                    </div>
                  </div>
                </div>

                <div className="mt-4 sm:mt-0 flex flex-col sm:items-end" data-id="element-4256" data-mp="ygvdwp1g5uur">
                  <div className={`flex items-center text-sm ${dk.isDark ? 'text-gray-400' : 'text-gray-500'} mb-2`} data-id="element-4257" data-mp="13enes8k2krb3">
                    <CalendarIcon className="h-4 w-4 mr-1" data-id="element-4258" data-mp="pna2nfohqvq3" />
                    Next billing: {sub.nextBilling}
                  </div>
                  <div className="flex space-x-3" data-id="element-4259" data-mp="fpm22947eu00">
                    <button className={`flex items-center px-3 py-1.5 text-sm font-medium border rounded-md ${dk.isDark ? 'border-gray-600 hover:bg-gray-700' : 'border-gray-300 hover:bg-gray-50'}`} data-id="element-4260" data-mp="fnrkn4s55k0o">
                      <PauseIcon className="h-4 w-4 mr-1" data-id="element-4261" data-mp="apzq03043jss" />
                      Pause
                    </button>
                    <button className={`flex items-center px-3 py-1.5 text-sm font-medium border rounded-md text-red-600 border-red-200 hover:bg-red-50 dark:hover:bg-red-900/20`} data-id="element-4262" data-mp="2125lzey31lcz">
                      <XIcon className="h-4 w-4 mr-1" data-id="element-4263" data-mp="3pn4j1tn5f8ii" />
                      Cancel
                    </button>
                  </div>
                </div>
              </div>

              <div className={`px-6 py-4 border-t ${dk.isDark ? 'border-gray-700 bg-gray-750' : 'border-gray-100 bg-gray-50'} flex justify-between items-center`} data-id="element-4264" data-mp="3707s0odzyb0">
                <div className="flex items-center text-sm" data-id="element-4265" data-mp="d4elvtmu8b05">
                  <CreditCardIcon className="h-4 w-4 mr-2 text-gray-400" data-id="element-4266" data-mp="d6r487wicndq" />
                  <span data-id="element-4267" data-mp="85bg26z1a0r4">Visa ending in 4242</span>
                </div>
                <button className="text-sm text-indigo-600 hover:text-indigo-500 font-medium" data-id="element-4268" data-mp="m5ukz587cqp2">
                  Update Payment Method
                </button>
              </div>
            </div>)}

          {subscriptions.length === 0 && <div className={`text-center py-12 rounded-xl ${dk.isDark ? 'bg-gray-800' : 'bg-white'}`} data-id="element-4269" data-mp="2nyslzoc4upl3">
              <BoxIcon className="h-12 w-12 mx-auto text-gray-400 mb-4" data-id="element-4270" data-mp="2ld2rmx85f7p1" />
              <h3 className="text-lg font-medium mb-2" data-id="element-4271" data-mp="2pe4r9f5z9lrj">
                No active subscriptions
              </h3>
              <p className="text-gray-500 mb-6" data-id="element-4272" data-mp="2udhfa38l4yvp">
                You aren't subscribed to any book boxes yet.
              </p>
              <button className="px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700" data-id="element-4273" data-mp="2zb9hbq2y21dm">
                Browse Book Boxes
              </button>
            </div>}
        </div>

        <div className="mt-12" data-id="element-4274" data-mp="26ooosmaqfj8h">
          <h2 className="text-xl font-bold mb-4" data-id="element-4275" data-mp="26lkdl4yunn8b">Billing History</h2>
          <div className={`rounded-xl shadow-sm overflow-hidden ${dk.isDark ? 'bg-gray-800' : 'bg-white'}`} data-id="element-4276" data-mp="2blyb3t2tres3">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700" data-id="element-4277" data-mp="2gfje5zj9yyy5">
              <thead className={dk.isDark ? 'bg-gray-700' : 'bg-gray-50'} data-id="element-4278" data-mp="1ixsqr7fonrss">
                <tr data-id="element-4279" data-mp="1nvujkk2wv5hg">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4280" data-mp="1nvb377swsp5j">
                    Date
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4281" data-mp="1be9xm8cq6i6h">
                    Description
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4282" data-mp="11gdofm3clxb0">
                    Amount
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4283" data-mp="xg39vl1hpykj">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className={`divide-y ${dk.isDark ? 'divide-gray-700' : 'divide-gray-200'}`} data-id="element-4284" data-mp="np8qqpjjjf3b">
                <tr data-id="element-4285" data-mp="dqjfvgq2auwk">
                  <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-4286" data-mp="dr18829lsoz7">
                    Oct 15, 2023
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-4287" data-mp="9ppscogj7i47">
                    Bookish & Spice Box - October
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-4288" data-mp="435qw65l2qzb">
                    $39.99
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-4289" data-mp="3m9bryd7qbvmi">
                    <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800" data-id="element-4290" data-mp="3mb4w9luve3rc">
                      Paid
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
};
export default ManageSubscriptions;